export class SearchAllEvent {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "plan",
            "baseName": "plan",
            "type": "SearchAllPlan",
            "format": ""
        },
        {
            "name": "section",
            "baseName": "section",
            "type": "SearchAllSection",
            "format": ""
        },
        {
            "name": "done",
            "baseName": "done",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchAllEvent.attributeTypeMap;
    }
    constructor() {
    }
}
